import { isObject } from 'Utils/common';
import { app } from '@/main';

export default {
  computed: {
    $_toaster_component() {
      return app.$children?.[0]?.$refs.toaster;
    },
  },
  methods: {
    /**
     * Normalize options
     * @param options
     * @returns {{timeout: number}}
     */
    $_toaster_normalizeOptions(options) {
      if (options === false) return { timeout: 0 };
      if (typeof options === 'number') return { timeout: options };
      return isObject(options) ? options : {};
    },
    /**
     * Show success toaster message
     * @param text {String} - text for message
     * @param options {Object|Boolean|Number} - get options as object, false|number as timeout
     * @returns {Number} - return toaster id
     */
    $_toaster_success(text, options = {}) {
      const normalizedOptions = this.$_toaster_normalizeOptions(options);
      return this.$_toaster_add(text, { ...normalizedOptions, type: 'success' });
    },
    /**
     * Show error toaster message
     * @param text {String} - text for message
     * @param options {Object|Boolean} - get options as object, false|number as timeout
     * @returns {Number} - return toaster id
     */
    $_toaster_error(text, options = {}) {
      const normalizedOptions = this.$_toaster_normalizeOptions(options);
      return this.$_toaster_add(text, { ...normalizedOptions, type: 'error' });
    },
    /**
     * Show info toaster message
     * @param text {String|Array} - text for message, String as simple message,
     *   array with 2 string as simple and more text
     * @param options {Object|Boolean|Number} - get options as object, false|number as timeout
     * @returns {Number} - return toaster id
     */
    $_toaster_info(text, options = {}) {
      const normalizedOptions = this.$_toaster_normalizeOptions(options);
      return this.$_toaster_add(text, { ...normalizedOptions, type: 'info' });
    },
    /**
     * Show warning toaster message
     * @param text {String|Array} - text for message, String as simple message,
     *   array with 2 string as simple and more text
     * @param options {Object|Boolean|Number} - get options as object, false|number as timeout
     * @returns {Number} - return toaster id
     */
    $_toaster_warning(text, options = {}) {
      const normalizedOptions = this.$_toaster_normalizeOptions(options);
      return this.$_toaster_add(text, { ...normalizedOptions, type: 'warning' });
    },
    /**
     * Show toaster message
     * @param text {String|Array} - text for message, String as simple message,
     * @param options {Object|Boolean|Number} - get options as object, false|number as timeout
     * @returns {*|Number}
     */
    $_toaster_message(text, options = {}) {
      const normalizedOptions = this.$_toaster_normalizeOptions(options);
      return this.$_toaster_add(text, { ...normalizedOptions });
    },
    /**
     * Add toaster to toaster component
     * @param text {String} - text for message
     * @param options {Object} - options for toaster
     * @returns {Number} - return toaster id
     */
    $_toaster_add(text, options) {
      return this.$_toaster_component.addItem(text, { ...options });
    },
    /**
     * Hide toaster
     * @param toasterId {Number} - Toaster id
     * @returns {null|undefined}
     */
    $_toaster_hide(toasterId) {
      if (!this.$_toaster_component.removeItem) return null;
      return this.$_toaster_component.removeItem(toasterId);
    },
  },
};
